function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:10px;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M174,451.47a228.62,228.62,0,0,1-7-56.24C167,269.17,269.17,167,395.23,167S623.49,269.17,623.49,395.23a228.6,228.6,0,0,1-7.67,58.88"
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-1",
  x1: 395.23,
  y1: 83.3,
  x2: 395.23,
  y2: 1.5
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-1",
  x1: 174.66,
  y1: 174.66,
  x2: 116.82,
  y2: 116.82
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-1",
  x1: 615.8,
  y1: 174.66,
  x2: 673.65,
  y2: 116.82
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-1",
  x1: 707.17,
  y1: 344.87,
  x2: 788.97,
  y2: 344.87
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-1",
  x1: 1.5,
  y1: 344.87,
  x2: 83.3,
  y2: 344.87
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M771.07,517c-139.5-57.13-202.42-77.72-375.84-80.41"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M19.4,517c139.5-57.13,202.42-77.72,375.83-80.41"
})));

const SvgMorning = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 790.47 518.46",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMorning, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/morning.ca3cfd1f.svg";
export { ForwardRef as ReactComponent };